module.exports = __webpack_public_path__ + "img/rekom-logo.797dcfad.png";